function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-.84 6.27c.25.25.25.66 0 .92-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19l-1.73-1.73a.658.658 0 010-.92l1.73-1.73c.25-.25.66-.25.92 0 .25.25.25.66 0 .92L15.89 18l1.27 1.27zm4.32-.81l-1.73 1.73c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 010-.92L20.1 18l-1.27-1.27a.658.658 0 010-.92c.25-.25.66-.25.92 0l1.73 1.73c.25.26.25.66 0 .92z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 7v7c-.83-.63-1.87-1-3-1-2.76 0-5 2.24-5 5 0 1.63.79 3.09 2 4H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h.93l.04 1.53c.02.81.69 1.47 1.5 1.47h3.03c.82 0 1.5-.68 1.5-1.5V2h1c3.5 0 5 2 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 2v1.5c0 .82-.68 1.5-1.5 1.5h-3.03c-.81 0-1.48-.66-1.5-1.47L8.93 2H15z"
})));